export const initialAddress = {
  city: '',
  country: null,
  state: null,
  zipCode: '',
  line1: '',
  line2: '',
};
